<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <p class="modal-text">Do you want to remove this collaborator from the list? This action cannot be undone.</p>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button variant="outline-danger" block @click="removeCollaborator">Remove collaborator</b-button>
  </div>
</template>

<script>
  import {db} from "../../../main";
  import firebase from "firebase";
  import router from "../../../router";

  export default {
    name: "RemoveCollaborator.vue",
    data() {
      return {
        toDoListId: null,
        collaboratorId: null,
        collaboratorInformation: {},
      }
    },
    methods: {
      removeCollaborator() {
        db
          .collectionGroup('user_collaborative_to_do_list_participation')
          .where('collaborativeToDoListId', '==', this.toDoListId)
          .where('collaboratorId', '==', this.collaboratorId)
          .get()
          .then(querySnapshot => {
            querySnapshot.docs.map(doc => doc.ref.delete())
          })

        db
          .collection('collaborative_to_do_lists')
          .doc(this.toDoListId)
          .update('toDoListCollaboratorId', firebase.firestore.FieldValue.arrayRemove(this.collaboratorId))

        db
          .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
          .where('assigneeId', '==', this.collaboratorId)
          .get()
          .then(querySnapshot => {
            querySnapshot.docs.map(doc => doc.ref.update({
              assigned: false,
              assigneeId: null,
              assigneeName: null
            }))
          })

        // notify the removed user for the removal
        const date = new Date();
        const notificationCreationTime = date.getTime()

        const removeCollaboratorNotification = {
          collaborativeToDoListId: this.toDoListId,
          notificationMessage: 'You have been removed from \"' + this.collaboratorInformation.collaborativeToDoListName + '\"',
          notificationType: 'Remove Collaborator',
          notificationCreationTime: notificationCreationTime,
          notificationCreationDate: firebase.firestore.FieldValue.serverTimestamp()
        }

        db.collection('users/' + this.collaboratorId + '/notifications')
          .add(removeCollaboratorNotification)

        // notify the current users about the user that left the collaborator list
        const leaveCollaborativeListNotification = {
          collaborativeToDoListId: this.toDoListId,
          notificationMessage: this.collaboratorInformation.collaboratorName.toUpperCase() + ' left \" ' + this.collaboratorInformation.collaborativeToDoListName + '\"',
          notificationType: 'Remove Collaborator',
          notificationCreationTime: notificationCreationTime,
          notificationCreationDate: firebase.firestore.FieldValue.serverTimestamp()
        }

        // send the notification to every user EXCEPT the user left
        db
          .collection('collaborative_to_do_lists')
          .doc(this.toDoListId)
          .get()
          .then(doc => {
            const toDoListCollaboratorId = doc.data().toDoListCollaboratorId
            toDoListCollaboratorId.forEach(collaboratorId => {
              if (collaboratorId !== this.collaboratorInformation.collaboratorId) {
                db
                  .collection('users/' + collaboratorId + '/notifications')
                  .add(leaveCollaborativeListNotification)
              }
            })
          })

        this.hideModal('collaborator-option-modal')
        router.push({ name: 'View Collaborators', params: { collaborativeListId: this.toDoListId }})

      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    },
    mounted() {
      this.toDoListId = this.$route.params.collaborativeListId
      this.collaboratorId = this.$route.params.collaboratorId

      // retrieve the user role information
      db
        .collection('users/' + this.collaboratorId + '/user_collaborative_to_do_list_participation')
        .where('collaborativeToDoListId', '==', this.toDoListId)
        .get()
        .then(querySnapshot => {
          const userCollaborativeToDoListParticipatedObject = querySnapshot.docs.map(doc => doc.data())
          this.collaboratorInformation = userCollaborativeToDoListParticipatedObject[0]
        })
    }
  }
</script>

<style scoped>
  .input-container {
    margin-bottom: 1em;
  }

  .modal-text {
    margin-bottom: 0;
  }
</style>
